var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"is-full-page":true,"loader":"spinner","width":50,"height":50,"color":"#9C27B0"}})}
var staticRenderFns = []

export { render, staticRenderFns }